import {createFileRoute} from '@tanstack/react-router'
import {firstLevelIndexRoute} from "../../../../../../utils/collectionListing";

export const Route = createFileRoute('/_site/users/_public_profile/collection/$username/$primarySorting/')({
    ...firstLevelIndexRoute("/users/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName"),
});
